import { AcademicFeeDto } from './academicfeedto';
import { VatPatternDto } from './vatPattern/vatpatterndto';


export class AcademicFeePriceDto {
    idOwnAcademicFeePrice?: number;
    startDate?: string;
    endDate?: string;
    firstTermPayment?: boolean;
    price?: number;
    ownAcademicFeeDto?: AcademicFeeDto;
    vatPatternDto?: VatPatternDto;

    constructor(data?: Partial<AcademicFeePriceDto>) {
        Object.assign(this, data);
    }
}

